import { models } from '@kurtosys/ksys-app-template';
export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	token: '0059eec6-ffeb-440a-9f3b-8c1221f7b654',
	serviceUrl: 'https://api.fundpress.io',
};